import React, { useCallback, useEffect, useState } from "react";

import classNames from "classnames/bind";
import { SettingIcon, DeleteIcon, OnStatus, OffStatus, LoseConnectStatus, WeakConnectStatus, EditIcon, CameraActiveIcon, VideoActiveIcon } from "../../../components/Icons/Icons";
import styles from './Camera.module.css'
import { sorterArrayChildIsManyObj } from "../../../utils";
import NameCol from "../../../components/NameCol";
import RenderStatus from "../../../components/StatusRender";
import { Link } from "react-router-dom";
import ReloadIcon from "../../../components/Icons/CameraControl/ReloadIcon";
import { Toast } from "../../../components";
import streamingClient from "../../../services/streamingClient";
import { useStoreContext } from "../../../hooks/useStoreContext";
import { actions } from "../../../store";

const cx = classNames.bind(styles)

const TableCamera = ({ data, showAlert, showModal, showModalMore, showStream }) => {
  const [toggleSort, setToggleSort] = useState(false);
  const [method, setMethod] = useState('');
  const [dataTable, setDataTable] = useState();
  const companyCode = sessionStorage.getItem('company_code');
  const [dataStore, dispatch] = useStoreContext();
  useEffect(() => {
    const newData = data ? [...data] : null
    if (newData && method.length > 0) {
      switch (toggleSort) {
        case 'up':
          const dataSortUp = sorterArrayChildIsManyObj(newData, 'CAMERA', method)
          setDataTable(dataSortUp)
          if (method === 'MAIN_SOURCE') {
            setDataTable(dataSortUp.reverse());
          } else {
            setDataTable(dataSortUp);
          }
          break;
        case 'down':
          const dataSortDown = sorterArrayChildIsManyObj(newData, 'CAMERA', method)
          if (method === 'MAIN_SOURCE') {
            setDataTable(dataSortDown);
          } else {
            setDataTable(dataSortDown.reverse());
          }
          break;
        default:
          setDataTable(newData)
          break;
      }
    } else {
      setDataTable(newData)
    }
  }, [data, toggleSort, method])

  const handleSort = (type, method) => {
    if (type !== toggleSort) {
      setToggleSort(type)
      setMethod(method)
    } else {
      setToggleSort(false)
      setMethod('')
    }
  }
  const handleReLoadCam = async (code) => {
    try {
      await streamingClient.post("/streamManagement/post-restart-streaming/", {
        camera_id: code,
      });
      Toast.open("Khởi động lại thành công", "success");
    } catch (error) {
      Toast.open("Vui lòng thử lại sau vài phút", "danger");
    }
  }
  const handleViewPlayback = (code_cam, name_cam, code_wareHouse) => {
    let dataAdd = {
      type: 'cam',
      add: true,
      data: [{ name: name_cam, code: code_cam, status: true }],
      warehouseCode: code_wareHouse,
    }
    dispatch(actions.getListCodeCamera(dataAdd))
  }
  const handleViewStream = (code_cam) => {
    showStream(code_cam)
  }
  return (
    <table className={cx("table")}>
      <thead>
        <tr>
          <th style={{ textAlign: 'center' }}>STT</th>
          <th>
            <NameCol active={method} title={'Tên camera'} handleSort={handleSort} method={'NAME_CAM'} />
          </th>
          <th>
            <NameCol active={method} title={'Địa điểm'} handleSort={handleSort} method={'PROVINCE_NAME'} />
          </th>
          <th >
            <div className={cx('number-columns')}>
              <NameCol active={method} title={'Độ phân giải'} handleSort={handleSort} method={'MAIN_SOURCE'} />
            </div>
          </th>
          <th >
            <div className={cx('number-columns')}>
              <NameCol active={method} title={'Nhóm camera'} handleSort={handleSort} method={'GROUP_COUNT'} />
            </div>
          </th>
          <th>
            <div className={cx('number-columns')}>
              <NameCol active={method} title={'Dịch vụ'} handleSort={handleSort} method={'SERVICE_COUNT'} />
            </div>
          </th>
          <th>
            <div className={cx('number-columns')} style={{ padding: 0, textAlign: 'center' }}>Hành động</div>
          </th>
        </tr>
      </thead>
      <tbody>
        {dataTable &&
          dataTable.length > 0 &&
          dataTable.map((item, index) => {
            return (
              <tr key={index}>
                <td onClick={(e) => showModal(item?.CAMERA?.CODE)}>
                  <div style={{ textAlign: 'center' }}>
                    {index + 1}
                  </div>
                </td>
                <td onClick={(e) => showModal(item?.CAMERA?.CODE)}>
                  <div
                    style={{
                      display: "flex",
                      gap: 10,
                      alignItems: "center",
                    }}
                  >
                    <span className={cx('On')}>
                      <RenderStatus companyCode={companyCode} status={item.CAMERA.STATUS_ACTIVE} />
                      <p className={cx('tooltip')}>
                        {item?.CAMERA?.MESSAGE}
                      </p>
                    </span>
                    {item?.CAMERA?.NAME_CAM}
                  </div>
                </td>
                <td onClick={(e) => showModal(item?.CAMERA?.CODE)}>{item?.CAMERA?.PROVINCE_NAME}</td>
                <td onClick={(e) => showModal(item?.CAMERA?.CODE)}>
                  <div className={cx('number-columns')}>{item?.CAMERA?.MAIN_SOURCE}</div>
                </td>
                <td style={{ textAlign: 'center' }} onClick={() => showModalMore(item?.GROUP_NAME, 'group')}>
                  <div className={cx('number-columns', 'link', 'center')}>
                    {item?.GROUP_NAME.length}
                  </div>
                </td>
                <td onClick={() => showModalMore(item?.AI, 'service')} style={{ textAlign: 'center' }}>
                  <div className={cx('number-columns', "link", 'center')}>{item?.CAMERA?.SERVICE_COUNT}</div>
                </td>
                {/* {sessionStorage.getItem("role") === "A" && <td> */}
                <td style={{ width: '15%', textAlign: 'right' }}>
                  <div className={cx('number-columns')} style={{ display: 'flex', padding: 0, gap: 8 }}>
                    <button onClick={(e) => handleViewStream(item?.CAMERA?.CODE)} className={cx('btn_options')}>
                      <CameraActiveIcon />
                      <div className={cx('tooltip')}>
                        Xem trực tiếp
                      </div>
                    </button>
                    <Link to={'/playback-video'}
                      className={cx('btn_options')}
                      onClick={(e) => handleViewPlayback(item?.CAMERA?.CODE, item?.CAMERA?.NAME_CAM, item?.CAMERA?.WAREHOUSE_CODE)}>
                      <VideoActiveIcon />
                      <div className={cx('tooltip')}>
                        Xem lại
                      </div>
                    </Link>
                    <Link to={`/admin/camera/edit/${item?.CAMERA?.CODE}`}
                      className={cx('btn_options')}
                    >
                      <div className={cx('tooltip')}>
                        Xem thông tin
                      </div>
                      <EditIcon />
                    </Link>
                    <button onClick={(e) => handleReLoadCam(item?.CAMERA?.CODE)} className={cx('btn_options')}>
                      <ReloadIcon />
                      <div className={cx('tooltip')}>
                        Khởi động lại
                      </div>
                    </button>
                    <button onClick={(e) => showModal(item?.CAMERA?.CODE)} className={cx('btn_options')}>
                      <SettingIcon />
                      <div className={cx('tooltip')} style={{left: '-300%'}}>
                        Cài đặt
                      </div>
                    </button>
                    <button onClick={(e) => showAlert(item?.CAMERA?.CODE)} className={cx('btn_options')}>
                      <DeleteIcon />
                      <div className={cx('tooltip')} style={{left: '-400%'}}>
                        Xóa
                      </div>
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table >
  );
};

export default TableCamera;
